// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2cnhM","type":"styles_type__3ZuvB","choices":"styles_choices__w--M-"};